import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Validators, FormGroup, FormBuilder, FormControl } from '@angular/forms';
// Rashmi
import { DashboardService } from '../../dashboard/dashboard.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-user-subscription-dilog',
  templateUrl: './user-subscription-dilog.component.html',
  styleUrls: ['./user-subscription-dilog.component.scss']
})
export class UserSubscriptionDilogComponent implements OnInit {
  // R
  private subscriptionDGUserDate: Subject<any> = new Subject();
  renewForm: FormGroup;
  maxDate = new Date();
  // R
  subdate: any;
  submitted: boolean = false;
  // added to constructor
  // private dashbordService: DashboardService,
  constructor(private dashbordService: DashboardService, @Inject(MatDialogRef) public dialogRef: MatDialogRef<UserSubscriptionDilogComponent>,
  @Inject(MAT_DIALOG_DATA) public data: UserSubscriptionDilogComponent,private fb: FormBuilder) {
    
   }
  //  R
   public subscrptionDate = this.data;

  onNoClick(): void {
    this.dialogRef.close();
  }
  onConfirm(): void {
    // Close the dialog, return true
    // R
    // this.submitted = true;
    // if (this.renewForm.invalid) {
    //   return;
    // }

    this.dialogRef.close(this.renewForm.value);
    console.log(this.renewForm.value) 
  }
  onDismiss(): void {
    // Close the dialog, return false
    this.dialogRef.close(false);
  }

  ngOnInit() {
    // console.log(this.subscrptionDate);
    this.renewForm = this.fb.group({
      // We can set default values by passing in the corresponding value or leave blank if we wish to not set the value. For our example, we’ll default the gender to female.
      // start_date: ['', [Validators.required]],
      // R
      start_date: new FormControl(''),
      end_date: new FormControl('',[Validators.required,])
      
     
    }
    );
    // R
    this.getSubscriptionDateByUserId();
  }
  get f() { return this.renewForm.controls; }

  onChange(value){

  }
// R
  getSubscriptionDateByUserId() {
    const param = {
        user_id: this.subscrptionDate
    }
    // this.deviceObject = {
    //   user_id: userId,
    // }
    this.dashbordService.getSubscriptionDateByUserId(param)
      .pipe(takeUntil(this.subscriptionDGUserDate))
      .subscribe(
        async data => {
          this.subdate = data.resultObject
          // console.log(this.subdate);
          this.renewForm.controls.start_date.patchValue(
            this.subdate.start_dt
          );
        },
        err => {
          return console.error(err);
        }
      );
  }

 }
